<script>
import appConfig from '@src/app.config';
import Layout from '@layouts/main';
import News from '@views/news/home-index';
import Planning from '@views/jobs/planning';
import JobGeneral from '@views/jobs/index';
import Reports from '@views/reports/index';
import { mapState } from 'vuex';

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, News, Planning, JobGeneral, Reports },
  props: {
    areas: {
      required: true,
      type: Array,
      default: null,
    },
    locations: {
      required: true,
      type: Array,
      default: null,
    },
    jobStatuses: {
      required: true,
      type: Array,
      default: null,
    },
    mAreas: {
      required: true,
      type: Array,
      default: null,
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
  },
};
</script>

<template>
  <div>
    <Reports v-if="currentUser.homepage_content_option === 1" :areas="mAreas" :locations="locations"></Reports>
    <JobGeneral v-else-if="currentUser.homepage_content_option === 2" :areas="mAreas" :locations="locations" page-title="Jobs - General" :job-statuses="jobStatuses"></JobGeneral>
    <Planning v-else-if="currentUser.homepage_content_option === 3" :areas="mAreas" :locations="locations" page-title="Jobs - Planning" :job-statuses="jobStatuses"/>
    <Layout v-else>
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <News />
        </b-col>
      </b-row>
    </Layout>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
